import axios from "axios";
import { Fragment, useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ConfirmModal from "../../components/ConfirmModal";
import Loading from "../../components/Loading";
import "./Addfile.scss";

function Addfile() {
  let navigate = useNavigate();
  const fileInputs = useRef({});
  const { state } = useLocation();
  const [downloadData, setDownloadData] = useState([]);
  const [files, setFiles] = useState([]);
  const [filesFormData, setFilesFormData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  // Loading 핸들러
  const [visible, setVisible] = useState(false);

  // 모달 핸들러
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const closeModal2 = () => {
    setShowModal2(false);
  };
  useEffect(() => {
    getDownloadData();
  }, []);
  // Download 데이터 받아오기
  const getDownloadData = async () => {
    try {
      const response = await axios.get("/api/task-apply-form-attrs", {
        params: { applyProcessId: state },
      });
      setDownloadData(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  // 각각 파일 업로드
  const selectFile = (data) => (event) => {
    const maxSize = 200 * 1024 * 1024;
    if (event.target.files[0].size > maxSize) {
      return Swal.fire({
        icon: "error",
        title: "오류",
        text: "파일용량은 200MB를 넘을수없습니다",
        confirmButtonColor: "dodgerBlue",
      });
    }
    let tempObj = {};
    tempObj.parentType = data.id;
    tempObj.parentName = data.name;
    tempObj.parentId = state;
    tempObj.required = data.state;
    tempObj.name = event.target.files[0].name;
    // files.map((e, idx) => {
    //   if (e.parentType === data.id) {
    //     duplicatedIdx = idx;
    //   }
    // });
    // if (duplicatedIdx !== null) {
    //   setFilesFormData((state) => {
    //     const filteredState = filesFormData.filter(
    //       (e, idx) => duplicatedIdx !== idx
    //     );
    //     return [...filteredState, event.target.files[0]];
    //   });
    // } else {
    setFilesFormData((state) => {
      return [...state, event.target.files[0]];
    });

    setFiles((state) => {
      return [...state, tempObj];
    });
  };
  // 제출 Handler
  const submitHandler = async () => {
    window.scrollTo(0, 0);
    setVisible(true);
    // 필수업로드 파일 체크
    const filteredDownloadData = downloadData.filter((el) => el.state === 2);
    const filteredFiles = files.filter((el) => el.required === 2);
    if (filteredDownloadData.length !== filteredFiles.length) {
      setShowModal(true);
      setVisible(false);
      return;
    } else {
      for (let i = 0; i < filteredDownloadData.length; i++) {
        let duplicated = 0;
        for (let j = 0; j < filteredFiles.length; j++) {
          if (filteredDownloadData[i].id === filteredFiles[j].parentType) {
            duplicated += 1;
          }
        }
        if (duplicated > 1) {
          setShowModal(true);
          setVisible(false);
          return;
        }
      }
    }
    const formData = new FormData();
    for (let i = 0; i < filesFormData.length; i++) {
      formData.append("files", filesFormData[i]);
    }
    let jsonDocs = JSON.stringify(files);
    formData.append("docs", jsonDocs);
    try {
      if (files.length > 0) {
        const response = await axios.post(
          `/api/apply-proc/${state}/docs/owrite`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      const response2 = await axios.patch(`/api/apply-proc/${state}/complete`);
      setShowModal2(true);
      setVisible(false);
      Swal.fire({
        icon: "success",
        title: "완료",
        text: "신청완료",
        confirmButtonColor: "dodgerBlue",
        iconColor: "dodgerBlue",
      });
      navigate("/");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "오류",
        text: "업로드파일을 확인해주세요",
        confirmButtonColor: "dodgerBlue",
      });
      setVisible(false);
      console.log(err);
    }
  };
  // 파일 idx로 삭제
  const onClearAttachment = (event) => () => {
    const targetIndex = files.indexOf(event);
    const deletedFiles = files.filter(
      (el) => el.parentType !== event.parentType
    );
    const deletedFormFiles = filesFormData.splice(targetIndex, 1);
    setFiles(deletedFiles);
    setFilesFormData(deletedFormFiles);

    if (fileInputs.current[event.parentType]) {
      fileInputs.current[event.parentType].value = "";
    }
  };
  return (
    <>
      {showModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"파일업로드"}
          content={`필수업로드 파일을 업로드 해주세요`}
        />
      ) : null}
      {showModal2 ? (
        <ConfirmModal
          closeModal={closeModal2}
          modalTitle={"신청완료"}
          content={`신청이완료되었습니다.`}
        />
      ) : null}
      <div className="step3_Addfile">
        <div className="contain my_Addfile_wrap">
          <div className="addfile_upload tilte_wrap">
            <h3 className="addfile_subject">첨부파일 업로드</h3>
            <h3 className="addfile_subject">업로드된 파일</h3>
          </div>
          {downloadData.length === 0 ? (
            <>
              <span style={{ color: "red" }}>
                첨부파일 업로드에 업로드할 파일이 없는경우 신청하기 버튼을
                눌러주세요
              </span>
            </>
          ) : null}
          <div style={{ display: "flex" }}>
            <div>
              {downloadData.map((e, idx) => {
                return (
                  <Fragment key={idx}>
                    <div className="addfile_wrap">
                      <div className="addfile_upload">
                        <div
                          className={
                            files.filter((el) => el.parentType === e.id)
                              .length > 0
                              ? "uploaded"
                              : "addfile_upload_status"
                          }
                        >
                          <label htmlFor={e.id}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                wordBreak: "break-all",
                              }}
                            >
                              {e.name}
                              {e.state === 2 ? (
                                <>
                                  <p style={{ color: "red", fontSize: "12px" }}>
                                    (필수업로드 파일입니다)
                                  </p>
                                </>
                              ) : null}
                            </div>
                            <span
                              className={
                                files.filter((el) => el.parentType === e.id)
                                  .length > 0
                                  ? "span_uploaded"
                                  : ""
                              }
                              style={{ cursor: "pointer" }}
                            >
                              첨부하기
                            </span>
                          </label>
                          <input
                            type="file"
                            onChange={selectFile(e)}
                            id={e.id}
                            ref={(el) => (fileInputs.current[e.id] = el)}
                            disabled={
                              files.filter((el) => el.parentType === e.id)
                                .length > 0
                                ? true
                                : false
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </Fragment>
                );
              })}
            </div>
            <section className="new">
              {files.map((e, idx) => {
                return (
                  <div key={idx} className="addfile_upload">
                    <b>
                      <small>{e.parentName}</small>
                    </b>
                    <div className="addfile_upload_status file_name">
                      <p className="">{e.name}</p>
                      <button onClick={onClearAttachment(e)}>
                        <MdClose />
                      </button>
                    </div>
                  </div>
                );
              })}
            </section>
          </div>
          <div
            style={{ margin: "2rem 0" }}
            className="input_wrap submit_btn addfile_submit_btn"
          >
            <button
              className="btn_line"
              onClick={() => {
                navigate("/");
              }}
            >
              취소
            </button>

            <button onClick={submitHandler} type="button" className="btn_color">
              신청하기
            </button>
            {visible && <Loading visible={visible} />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Addfile;
